import React, { useState } from "react";
import { Tabs, Card, Button } from "antd";
import { CustomizeForm } from "./customize-activity/customize-forms";
import { TableOfMembers } from "./customize-activity/table-of-members";
import { BackgroundImages } from "./customize-activity/background-images";
import { RcFile } from "antd/es/upload";

export const CustomizeActivityListMember: React.FC = () => {
  const [members, setMembers] = useState<string[]>([]);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("1");
  const [labels, setLabels] = useState<string[]>([]);
  const [backgroundImages, setBackgroundImages] = useState<{
    [key: string]: string;
  }>({
    customizeActivity: "",
  });

  const [labelCustomizeActivity, setLabelCustomizeActivity] =
    useState("หน้าแรก");

  const handleFileChange = (file: RcFile, cardType: string) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBackgroundImages((prev) => ({
        ...prev,
        [cardType]: reader.result as string,
      }));
    };
    reader.readAsDataURL(file);
    return false;
  };

  
  const saveall = () => {
    console.log("Submitted members:", members);
    console.log("Submitted state:", submitted);
    console.log("Background images:", backgroundImages);
  };
  

  return (
    <div className="min-h-screen flex flex-col">
      <Card className="w-full shadow-md rounded-xl p-6 mb-6 relative">
        <Button
          onClick={saveall}
          className="absolute top-4 right-4 p-3 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition"
        >
          Save
        </Button>

        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          className="mb-6"
        >
          <Tabs.TabPane
            tab="Customize Activity"
            key="1"
            className="px-4 py-2 bg-gray-100 rounded-xl shadow-md"
          >
            <CustomizeForm
              setMembers={setMembers}
              setSubmitted={setSubmitted}
              setActiveTab={setActiveTab}
              labels={labels}
              setLabels={setLabels}
              backgroundImages={backgroundImages}
              labelCustomizeActivity={labelCustomizeActivity}
              setLabelCustomizeActivity={setLabelCustomizeActivity}
              step={0}
              title={""}
              content={""}
            />
          </Tabs.TabPane>

          <Tabs.TabPane
            tab="Table of Members"
            key="2"
            className="px-4 py-2 bg-gray-100 rounded-xl shadow-md"
          >
            {submitted && (
              <TableOfMembers members={members} submitted={submitted} />
            )}
          </Tabs.TabPane>

          <Tabs.TabPane
            tab="Background Images"
            key="3"
            className="px-4 py-2 bg-gray-100 rounded-xl shadow-md"
          >
            <BackgroundImages
              backgroundImages={backgroundImages}
              handleFileChange={handleFileChange}
            />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </div>
  );
};
